// extracted by mini-css-extract-plugin
module.exports = {"agreementItem":"LoginAgreementItem_agreementItem__3QXrs","agreement":"LoginAgreementItem_agreement__1HAgn"};